<div *ngIf="isLoading" class="loading-overlay">
  <div class="loading-content">
    <div class="spinner"></div>
    <span class="loading-text">{{ loadingText }}</span>
  </div>
</div>
